<template>
  <svg
    class="nr-icon"
    :class="{ 'is-loading': name === 'loading' }"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="name === 'loading'">
      <path d="M12 3a9 9 0 1 0 9 9" />
    </template>
    <template v-else-if="name === 'arrow-left'">
      <path d="M19 12H5M11 18l-6-6 6-6" />
    </template>
    <template v-else-if="name === 'arrow-right'">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </template>
    <template v-else-if="name === 'arrow-down'">
      <path d="M12 5v14M6 13l6 6 6-6" />
    </template>
    <template v-else-if="name === 'arrow-up'">
      <path d="M12 19V5M6 11l6-6 6 6" />
    </template>
    <template v-else-if="name === 'backward'">
      <path d="M3 5v6h6M4.5 10A8 8 0 0 1 19 7M4.5 10a8 8 0 0 0 14.3 7" />
      <path d="M12 8l-3.5 4H12v4l4-4h-4z" />
    </template>
    <template v-else-if="name === 'forward'">
      <path d="M21 5v6h-6M19.5 10A8 8 0 0 0 5 7M19.5 10a8 8 0 0 1-14.3 7" />
      <path d="M12 8l3.5 4H12v4l-4-4h4z" />
    </template>
    <template v-else-if="name === 'back'">
      <path d="M19 12H5M11 18l-6-6 6-6M19 5v14" />
    </template>
    <template v-else-if="name === 'close'">
      <path d="M6 6l12 12M18 6L6 18" />
    </template>
    <template v-else-if="name === 'search'">
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </template>
    <template v-else-if="name === 'plus'">
      <path d="M12 5v14M5 12h14" />
    </template>
    <template v-else-if="name === 'minus'">
      <path d="M5 12h14" />
    </template>
    <template v-else-if="name === 'more'">
      <circle cx="5" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="19" cy="12" r="1.4" fill="currentColor" stroke="none" />
    </template>
    <template v-else-if="name === 'menu'">
      <path d="M4 7h16M4 12h16M4 17h16" />
    </template>
    <template v-else-if="name === 'tickets'">
      <path d="M4 5h16v4a2 2 0 0 0 0 6v4H4v-4a2 2 0 0 0 0-6z" />
      <path d="M14 5v14" />
    </template>
    <template v-else-if="name === 'time'">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </template>
    <template v-else-if="name === 'user'">
      <circle cx="12" cy="8" r="4" />
      <path d="M5 20c0-3.3 3-5 7-5s7 1.7 7 5" />
    </template>
    <template v-else-if="name === 'lock'">
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </template>
    <template v-else-if="name === 'view'">
      <path d="M3 12c2-4 5-6 9-6s7 2 9 6c-2 4-5 6-9 6s-7-2-9-6z" />
      <circle cx="12" cy="12" r="2.5" />
    </template>
    <template v-else-if="name === 'edit'">
      <path d="M4 20h16M6 16l9.5-9.5a2 2 0 0 1 2.8 0l.2.2a2 2 0 0 1 0 2.8L9 19l-4 1z" />
    </template>
    <template v-else-if="name === 'delete'">
      <path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13M10 11v6M14 11v6" />
    </template>
    <template v-else-if="name === 'download'">
      <path d="M12 3v12M7 10l5 5 5-5M5 20h14" />
    </template>
    <template v-else-if="name === 'upload'">
      <path d="M12 20V8M7 13l5-5 5 5M5 4h14" />
    </template>
    <template v-else-if="name === 'star-off'">
      <path d="M12 4l2.5 5 5.5.8-4 3.9.9 5.5L12 16.6 7.1 19.2l.9-5.5-4-3.9 5.5-.8z" />
    </template>
    <template v-else-if="name === 'star-on'">
      <path d="M12 4l2.5 5 5.5.8-4 3.9.9 5.5L12 16.6 7.1 19.2l.9-5.5-4-3.9 5.5-.8z" fill="currentColor" stroke="none" />
    </template>
    <template v-else-if="name === 'collection'">
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <rect x="8" y="7" width="8" height="1" />
      <rect x="8" y="11" width="6" height="1" />
      <path d="M8 16h4" />
    </template>
    <template v-else-if="name === 'collection-tag'">
      <path d="M4 6a2 2 0 0 1 2-2h5l9 9a2 2 0 0 1 0 2.8l-4.2 4.2a2 2 0 0 1-2.8 0L4 11z" />
      <circle cx="9" cy="9" r="1" />
    </template>
    <template v-else-if="name === 'document'">
      <path d="M6 3h8l4 4v14H6z" />
      <path d="M14 3v4h4M9 12h6M9 16h6" />
    </template>
    <template v-else-if="name === 'document-copy'">
      <rect x="8" y="8" width="11" height="12" rx="2" />
      <path d="M5 16V5a2 2 0 0 1 2-2h6" />
    </template>
    <template v-else-if="name === 'notebook-1'">
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M9 3v18M12 8h4M12 12h4" />
    </template>
    <template v-else-if="name === 'notebook-2'">
      <path d="M4 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />
      <path d="M8 4v16M11 9h6M11 13h6" />
    </template>
    <template v-else-if="name === 'reading'">
      <path d="M2 6c3-2 6 0 10 0s7-2 10 0v12c-3-2-6 0-10 0s-7-2-10 0z" />
      <path d="M12 6v12" />
    </template>
    <template v-else-if="name === 'right'">
      <path d="M9 6l6 6-6 6" />
    </template>
    <template v-else-if="name === 'setting'">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" />
    </template>
    <template v-else-if="name === 'sunny'">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
    </template>
    <template v-else-if="name === 'microphone'">
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
    </template>
    <template v-else-if="name === 'headphones'">
      <path d="M4 13v-2a8 8 0 0 1 16 0v2" />
      <rect x="3" y="12" width="4" height="7" rx="2" />
      <rect x="17" y="12" width="4" height="7" rx="2" />
    </template>
    <template v-else-if="name === 'video-play'">
      <circle cx="12" cy="12" r="9" />
      <path d="M10 9l5 3-5 3z" fill="currentColor" stroke="none" />
    </template>
    <template v-else-if="name === 'video-pause'">
      <circle cx="12" cy="12" r="9" />
      <path d="M10 9v6M14 9v6" stroke-width="2" />
    </template>
    <template v-else-if="name === 'switch-button'">
      <path d="M7 8a5 5 0 0 0 0 8M10 8h4M10 16h4" />
      <circle cx="17" cy="8" r="3.5" />
      <path d="M16 12.5v0" stroke-width="2" />
    </template>
    <template v-else-if="name === 'position'">
      <path d="M12 3l7 17-7-3.5L5 20z" />
      <circle cx="12" cy="12" r="1.5" />
    </template>
    <template v-else-if="name === 'sort'">
      <path d="M8 6l-4 4h8zM8 18l-4-4h8z" />
      <path d="M12 10h8M12 14h8" />
    </template>
    <template v-else-if="name === 'info'">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8v.5" />
    </template>
    <template v-else-if="name === 'success'">
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 12.5l2.3 2.3 4.7-5" />
    </template>
    <template v-else-if="name === 'warning'">
      <path d="M12 3l9 16H3z" />
      <path d="M12 10v4M12 17v.5" />
    </template>
    <template v-else-if="name === 'error'">
      <circle cx="12" cy="12" r="9" />
      <path d="M9 9l6 6M15 9l-6 6" />
    </template>
    <template v-else-if="name === 'edit-outline'">
      <path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4z" />
    </template>
    <template v-else-if="name === 'circle-check'">
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 12.5l2.3 2.3 4.7-5" />
    </template>
    <template v-else-if="name === 'check'">
      <path d="M5 12.5l4.5 4.5L19 7" stroke-width="2.4" />
    </template>
    <template v-else-if="name === 'moon'">
      <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />
    </template>
    <template v-else-if="name === 'sun'">
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2v2.2M12 19.8V22M2 12h2.2M19.8 12H22M4.9 4.9l1.6 1.6M17.5 17.5l1.6 1.6M19.1 4.9l-1.6 1.6M6.5 17.5l-1.6 1.6" />
    </template>
    <template v-else-if="name === 'list-lines'">
      <path d="M9 6h11M9 12h11M9 18h11" />
      <circle cx="4.5" cy="6" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="4.5" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="4.5" cy="18" r="1.2" fill="currentColor" stroke="none" />
    </template>
    <template v-else-if="name === 'progress-bar'">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M7 9v6M12 9v6M17 9v6" />
    </template>
    <template v-else-if="name === 'chat'">
      <path d="M20 12a7.5 7.5 0 0 1-11 6.6L4 20l1.4-4.2A7.5 7.5 0 1 1 20 12z" />
    </template>
    <template v-else-if="name === 'warning-outline'">
      <path d="M12 3l9 16H3z" />
      <path d="M12 10v4M12 17v.5" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'NrIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [String, Number], default: 16 }
  }
}
</script>

<style scoped>
.nr-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
